import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ChevronDown, ArrowUpRight } from "lucide-react";
import { ICONS, THEME, servicesOf, doctorFor } from "@/data/site";

const Item = ({ s, t, active, onHover }) => {
  const Icon = ICONS[s.icon];
  return (
    <li onMouseEnter={onHover}>
      <Link to={`/services/${s.slug}`} data-testid={`mega-item-${s.slug}`}
        className={`flex items-center gap-3 rounded-xl px-3 py-2.5 transition-colors ${active ? t.tint : "hover:bg-sand"}`}>
        <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${active ? `${t.bg} text-white` : `${t.tint} ${t.text}`}`}><Icon className="h-4 w-4" /></span>
        <span className="min-w-0">
          <span className="block truncate text-[15px] font-semibold text-ink">{s.titleHi}</span>
          <span className="font-en block truncate text-xs text-muted2">{s.titleEn}</span>
        </span>
      </Link>
    </li>
  );
};

const Preview = ({ s, t, doc }) => (
  <div className="flex flex-col p-6">
    <div className="relative h-36 overflow-hidden rounded-2xl">
      <img src={s.image} alt="" className="h-full w-full object-cover" />
      <span className={`absolute left-3 top-3 rounded-full px-3 py-1 text-xs font-semibold text-white ${t.bg}`}>{doc.nameHi}</span>
    </div>
    <p className="font-display mt-4 text-xl text-ink">{s.titleHi}</p>
    <p className="mt-1 text-sm text-muted2">{s.summaryHi}</p>
    <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5 text-sm text-ink/80">
      {s.items.slice(0, 4).map((i) => <li key={i.en} className="truncate">• {i.hi}</li>)}
    </ul>
    <div className="mt-auto flex items-center justify-between pt-5">
      <Link to={`/services/${s.slug}`} className={`inline-flex items-center gap-1 text-sm font-semibold ${t.text}`}>पूरी जानकारी <ArrowUpRight className="h-4 w-4" /></Link>
      <Link to={t.path} data-testid={`mega-viewall-${t.key}`} className="text-sm font-semibold text-muted2 hover:text-ink">सभी देखें →</Link>
    </div>
  </div>
);

export const MegaMenu = ({ dept }) => {
  const t = THEME[dept];
  const list = servicesOf(dept);
  const [active, setActive] = useState(list[0].slug);
  const s = list.find((x) => x.slug === active) || list[0];
  return (
    <div className="group relative" data-testid={`nav-menu-${dept}`}>
      <NavLink to={t.path} data-testid={`nav-link-${dept}`}
        className={({ isActive }) => `flex items-center gap-1 py-2 text-[15px] font-semibold transition-colors ${isActive ? t.text : "text-ink hover:" + t.text}`}>
        <span className={`h-2 w-2 rounded-full ${t.bg}`} /> <span className="flex flex-col leading-tight"><span className="font-en">{t.menuEn}</span><span className="text-[11px] font-medium text-muted2">{t.labelHi}</span></span>
        <ChevronDown className="h-4 w-4 transition-transform duration-300 group-hover:rotate-180" />
      </NavLink>
      <div className="invisible absolute left-1/2 top-full z-50 w-[820px] -translate-x-1/2 pt-3 opacity-0 transition-all duration-300 group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
        <div data-testid={`mega-panel-${dept}`} className="grid grid-cols-12 overflow-hidden rounded-3xl border border-line bg-white shadow-2xl shadow-black/10">
          <div className={`col-span-12 flex items-center justify-between px-6 py-3 text-white ${t.bg}`}>
            <p className="font-display text-lg">{t.deptHi}</p>
            <p className="font-en text-xs text-white/80">{t.deptEn}</p>
          </div>
          <ul className="col-span-6 max-h-[420px] overflow-y-auto border-r border-line p-2">
            {list.map((x) => <Item key={x.slug} s={x} t={t} active={x.slug === active} onHover={() => setActive(x.slug)} />)}
          </ul>
          <div className="col-span-6"><Preview s={s} t={t} doc={doctorFor(dept)} /></div>
        </div>
      </div>
    </div>
  );
};
